import {db} from '../../../utils/firebase';

export const getTipsLangs = (fetchingState, setFetchingState, errors, setErrors) => {
    setFetchingState({...fetchingState, tips: true});

    return db
        .collection(`tipsCollection`)
        .get()
        .then((snapshot) => {
            const tipsLanguages = [];
            snapshot.forEach((doc) => {
                tipsLanguages.push({id: doc.id, data: doc.data()})
            });

            return tipsLanguages;
        })
        .catch(error => setErrors({...errors, tips: error}))
        .finally(() => setFetchingState({...fetchingState, tips: false}));
}

export const saveTipsToDb = (tips, tipsCollectionName, fetchingState, setFetchingState, errors, setErrors) => {
    let isDataSent;
    setFetchingState({...fetchingState, tips: true});

    return db
        .doc(`tipsCollection/${tipsCollectionName}`)
        .set({tipsArray: tips})
        .then(() => isDataSent = true)
        .catch(error => {
            setErrors({...errors, tips: error});
            return isDataSent = false;
        })
        .finally(() => {
            setFetchingState({...fetchingState, tips: false});
            return isDataSent;
        });
}

export const getTipsFromDb = (tipsCollectionName, fetchingState, setFetchingState, errors, setErrors) => {
    setFetchingState({...fetchingState, tips: true});

    return db
        .doc(`tipsCollection/${tipsCollectionName}`)
        .get()
        .then((doc) => {
            if (!doc.exists) {
                setErrors({...errors, tips: 'Нет документа подсказок в базе'});
                return [];
            }

            return doc.data().tipsArray;
        })
        .catch((error) => setErrors({...errors, tips: error}))
        .finally(() => setFetchingState({...fetchingState, tips: false}))
}
